import { useEffect, useState } from "react";
import { apiRoute } from "services";
import API from "services/lib/api";
import { mimeTypes } from "utils/mime";

const FILE_TYPES = {
    IMAGE: 'image',
    VIDEO: 'video',
    AUDIO: 'audio',
    PDF: 'pdf',
    FILE: 'file'
};

const ModalPreviewFile = ({ fileName, fileType, preview, file }) => {
    const [mimeType, setMimeType] = useState("");
    const [blob, setBlobUrl] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const [previewType, setPreviewType] = useState(FILE_TYPES.FILE);

    const determineFileType = (mimeType) => {
        if (mimeType?.startsWith('image/')) return FILE_TYPES.IMAGE;
        if (mimeType?.startsWith('video/')) return FILE_TYPES.VIDEO;
        if (mimeType?.startsWith('audio/')) return FILE_TYPES.AUDIO;
        if (mimeType === 'application/pdf') return FILE_TYPES.PDF;
        return FILE_TYPES.FILE;
    };

    const imageUrlToBase64 = async (url) => {
        return await fetch(url)
            .then((response) => response.text())
    };

    const base64toBlob = async (data) => {
        try {
            const base64result = await imageUrlToBase64(preview);
            const base64Str = base64result.toString().replace(/^data:(.*,)?/, "");

            const fileName = file?.filename || file?.fileAttachmentName;
            const fileExtension = fileName?.split('.').pop()
            const mimeType = mimeTypes[fileExtension]
            setMimeType(mimeType);
            setBlobUrl(`data:${mimeType};base64,${base64Str}`);
        } catch (err) {
            console.error('Error converting to base64:', err);
        } finally {
            setIsLoading(false);
        }
    };

    const casualFile = () => {
        try {
            const fileName = file?.filename || file?.fileAttachmentName;
            const fileExtension = fileName?.split('.').pop()
            const mimeType = mimeTypes[fileExtension]
            setMimeType(mimeType);
            setBlobUrl(preview);
        } catch (err) {
            console.error('Error processing casual file:', err);
        } finally {
            setIsLoading(false);
        }
    }

    const getFileUrl = async () => {
        try {
            const url = apiRoute.getFileLink;
            const res = await API.get(url, {
                params: {
                    fileKey: preview,
                },
            });

            const data = res.data;
            const fileName = file?.filename || file?.fileAttachmentName;
            const fileExtension = fileName?.split('.').pop()
            const mimeType = mimeTypes[fileExtension];

            setMimeType(mimeType);
            setBlobUrl(data?.data);
        } catch (err) {
            console.error('Error fetching file:', err);
        } finally {
            setIsLoading(false);
        }
    };

    const handleFileSrc = () => {
        setIsLoading(true);
        if (file?.isEmailLink) {
            base64toBlob();
            return;
        } else {
            preview.startsWith("https") ? casualFile() : getFileUrl();
        }
    };

    useEffect(() => {
        handleFileSrc();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (mimeType) {
            setPreviewType(determineFileType(mimeType));
        }
    }, [mimeType]);

    if (isLoading) {
        return <div className="loading-spinner">Loading...</div>;
    }

    const renderPreview = () => {
        if (!blob) return null;

        switch (previewType) {
            case FILE_TYPES.IMAGE:
                return (
                    <img
                        src={blob}
                        alt={fileName || 'preview'}
                        className="preview__media"
                        style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
                    />
                );
            case FILE_TYPES.VIDEO:
                return (
                    <video className="preview__media" controls>
                        <source src={blob} type={mimeType} />
                    </video>
                );
            case FILE_TYPES.AUDIO:
                return (
                    <audio className="preview__media" controls>
                        <source src={blob} type={mimeType} />
                    </audio>
                );
            case FILE_TYPES.PDF:
            case FILE_TYPES.FILE:
            default:
                return (
                    <embed
                        key={blob}
                        width="100%"
                        height="100%"
                        src={blob}
                        type={mimeType}
                    />
                );
        }
    };

    return (
        <>
            {renderPreview()}
        </>
    );
};

export default ModalPreviewFile;
